/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `ATIVA` - Ativa * `PENDENTE` - Pendente * `DESATIVADA` - Desativada
 */
export enum SituacaoB96Enum {

    ATIVA = 'ATIVA',

    PENDENTE = 'PENDENTE',

    DESATIVADA = 'DESATIVADA'
}

